<template>
    <div>
    <Modal
        class-name="vertical-center-modal"
        :value="showSetModel && (DataType==3 || DataType==9)"
        :title="$t('edit')"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'800px','max-height':'800px','min-height':'350px'}">
        
        <Form ref="formDynamic" :model="formDynamic" :rules="ruleCustom" :label-width="80" >
           
             <div v-for="(item, index) in formDynamic.items" :key="index">
                <div style="display:flex;justify-content:flex-start;flex-wrap:wrap" >
                    <!--key5:'wordId',  key1:'Name-CN', key4:"Name-EN",key2:'Code',key3:'LanguageKey',ke6:'pageId_wordId' -->
               
                
                    <FormItem   v-if="languageKey.key3"  :label="$t(`BasicProduct.funcBox.titleName.${languageKey.key3}`) + item.index"  :prop="'items.' + index + '.'+languageKey.key3"  style="width:420px"
                         :rules="{required: true, message: languageKey.key3 + item.index +' can not be empty', trigger: 'change'}">
                       
                        <div v-if="isGener && !item.hasWord" class="ivu-input">{{ item.LanguageKey }} {{ local=='zh-CN'?item['Name-CN']:item['Name-EN'] }}</div>
                         
                        <template v-else>
                            <SearchSelectPage  :refName="'selcet'+index" listName="dealersList"  :showPage="true" :ref="'selcet'+index" :selectUrlQuery="{pageId:pageID}" :url="pagesIdListUrl"  labelName='wordCode'  isMultiple='2'  valName='id' :labelNameNew="local=='zh-CN'?'simpleChinese':'englishText'" keyword="wordCode" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValPage($event,item.index)"></SearchSelectPage>
                        </template>
                    </FormItem>
                    <FormItem   v-if="languageKey.key2"  :label="'Code' + item.index"  :prop="'items.' + index + '.'+languageKey.key2"  style="width:300px"
                         :rules="{required: true, message: languageKey.key2 + item.index +' can not be empty', trigger: 'blur'}">
                         <div v-if="DataType==9" type="text" style="border: 1px solid #dcdee2;padding: 0px 7px;border-radius: 4px;">{{item[languageKey.key2]}}</div>
                        <Input v-else type="text" v-model="item[languageKey.key2]" :placeholder="$t('inputPlaceholder')"></Input>
                          
                    </FormItem>
   
                </div>
                 
             </div>
            
            <FormItem v-if="isGener">
                <Button type="primary" @click="cancel">{{$t("cancel")}}</Button>
            </FormItem>
            <FormItem v-else>
                <Button type="primary" @click="handleSubmit('formDynamic')">{{$t("save")}}</Button>
                <!-- <Button @click="handleReset('formDynamic')" style="margin-left: 8px">{{$t("reset")}}</Button> -->
                <Button @click="cancel" style="margin-left: 8px">{{$t("cancel")}}</Button>
            </FormItem>
        </Form>
    </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showSetModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
// import SearchSelectPage from '@/views/common/selectListPage.vue';  //20220415
import SearchSelectPage from '@/views/common/selectListRecycle.vue';  //20220415
import { mapState } from 'vuex'
    export default {
        props: {
            showSetModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object,
            // languageKey:Object,
            DataType:String,
            // initdata:[Array,Object],
            pageId:[Number, String],
            isGener:{
                type:Boolean,
                default:false
            }
        },
        name: "Model7",
       
        data() {
            return {   
                disabled: false,//禁用确定按钮
                pagesIdListUrl: this.config.urlArray.pagesLangDictionaryList,//对应pageId的词条列表
                title: '设置',//弹框标题
                formData: {//表单数据
                   
                }, 
                index: 1,
                formDynamic: {
                    items: [
                        {},{}
                    ],
                },
                pageID:'',
                descText:'',
                wordList:[],
                wordListLoading:false,
                currInfoList:[],
                languageKey:{key1:'Name-CN', key4:"Name-EN",key2:'Code',key3:'LanguageKey',key5:'wordId',key6:'pageId_wordCode'},
                initData:[],
                initdataBoolean:[{'Name-CN':'',"Name-EN":"",Code:'false',LanguageKey : '','wordId':'','pageId_wordCode':'',index: 1,status: 1},{'Name-CN':'',"Name-EN":"",Code:'true',LanguageKey : '','wordId':'','pageId_wordCode':'',index: 2,status: 1}],
                initdataHexBoolean:[{'Name-CN':'',"Name-EN":"",Code:'0x00',LanguageKey : '','wordId':'','pageId_wordCode':'',index: 1,status: 1},{'Name-CN':'',"Name-EN":"",Code:'0x01',LanguageKey : '','wordId':'','pageId_wordCode':'',index: 2,status: 1}]
               
            }
        },
        components:{
            SearchSelectPage
        },
        watch:{
            DataType(newval,oldVal){
               let arr = newval==3?common.deepClone([{...this.initdataBoolean[0]},{...this.initdataBoolean[1]}]):common.deepClone([{...this.initdataHexBoolean[0]},{...this.initdataHexBoolean[1]}])
               this.initData = common.deepClone(arr)
               this.formDynamic.items = common.deepClone(arr)
            }
        },
        computed:{
            ...mapState(['local','selectId','wordListAll','wordListByPageId','pageIdStore']),
             ruleCustom(){
                 return {//验证
                }
             } 
        },
        created(){
            this.pageID = this.pageId || this.pageIdStore || ''
           
        },
        methods: {
            
            setSelectValPage(selItem,index){
                if(selItem){
                   (this.formDynamic.items[index-1])[this.languageKey.key5] = selItem.id+'';
                   (this.formDynamic.items[index-1])[this.languageKey.key3] = selItem.wordCode+'' || '';
                   (this.formDynamic.items[index-1])[this.languageKey.key6] = this.pageID+'_'+selItem.wordCode+''||'';
                   (this.formDynamic.items[index-1])[this.languageKey.key1] = selItem.simpleChinese+''|| '';
                   (this.formDynamic.items[index-1])[this.languageKey.key4] = selItem.englishText+''||''
                }else{
                    this.clearSelectVal(index)
                }
            },
           
            setDefaultSelectPage(){
                for(let i=0;i<this.formDynamic.items.length;i++){
                    let param = {
                        id:this.formDynamic.items[i].wordId,
                        wordCode:this.formDynamic.items[i].LanguageKey
                    }
                    console.log('paramparamparam',param)
                    if(this.$refs['selcet'+i] && this.$refs['selcet'+i][0]){

                        this.$refs['selcet'+i][0].setDefVal(param)
                    }
                }
            },
            clearSelectVal(index){
                if((this.formDynamic.items[index-1]) && (this.formDynamic.items[index-1])[this.languageKey.key3]){
                   (this.formDynamic.items[index-1])[this.languageKey.key5] = '';
                   (this.formDynamic.items[index-1])[this.languageKey.key3] = '';
                   (this.formDynamic.items[index-1])[this.languageKey.key6] = '';
                   (this.formDynamic.items[index-1])[this.languageKey.key1] = '';
                   (this.formDynamic.items[index-1])[this.languageKey.key4] = ''
               }
            },
            handleSubmit (name) {
                console.log('this.formDynamic.items',this.formDynamic.items)
                if(this.isGener){
                    return
                }
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        // console.log('this.formDynamic.items',this.formDynamic.items)
  
                        const arr5 = this.formDynamic.items.filter((item)=>item.status).map((item1)=>item1[this.languageKey.key3])
                        const arr6 = new Set(arr5)
                        if(arr5.length > arr6.size){
                            this.$Message.error('词条 重复');
                            return
                        }
                        let emitArr = this.formDynamic.items.filter((item)=>{
                           return  item.status==1
                        }).map(item=>{
                            delete item.status
                            delete item.index
                            delete item.hasWord
                            if(!item[this.languageKey.key6]){
                                item[this.languageKey.key6] = this.pageID+'_'+item[this.languageKey.key3]+''
                            }
                            return item
                        })
                        // console.log('emitArr',emitArr,this.descText)
                        
                        this.fn(emitArr,this.descText)
               
                    } else {
                        this.$Message.error('Fail!');
                    }
                })
            },
            handleReset (name) {
                
                this.$refs[name].resetFields();
            },
            async openOrClose(value) {
                if(value === true) {
                   
                    if(!Object.keys(this.editFormData).length) return
                    
                   
                        //  HexBoolean:{key1:'Name-CN', key4:"Name-EN",key2:'Code',key3:'LanguageKey',key5:'wordId',key6:'pageId_wordCode'},
                     console.log(66666,(this.editFormData.IndentyName.length))
                    if(this.type==1){
                        this.formDynamic.items = common.deepClone([{...this.initData[0]},{...this.initData[1]}])
                        this.index = 1   //好像没用
                        for(let i=0;i<this.formDynamic.items.length;i++){//请求wordlist数据
                            this.$refs['selcet'+i][0].getData()
                        }
                    }else{
                        if(this.editFormData.IndentyName.length==2){// 新版本格式
                            // this.formDynamic.items = [...JSON.parse(JSON.stringify(this.editFormData.IndentyName))] 
                            this.formDynamic.items = common.deepClone([...this.editFormData.IndentyName]) 
                            // console.log('this.formDynamic.items',this.formDynamic.items)
                            // console.log('this.editFormData.IndentyName',this.editFormData.IndentyName)
                            if(!this.formDynamic.items[0].LanguageKey){
                                this.formDynamic.items[0].LanguageKey = this.editFormData.IndentyName[0].LanguageKey
                                this.formDynamic.items[0].Code = this.editFormData.IndentyName[0].Code
                                this.formDynamic.items[1].LanguageKey = this.editFormData.IndentyName[1].LanguageKey
                                this.formDynamic.items[1].Code = this.editFormData.IndentyName[1].Code
                            }
                        }else if(this.editFormData.IndentyName.length==1){// 兼容旧版本格式
                            this.formDynamic.items[0]['Code']=this.DataType==9?'0x00':'false';
                            this.formDynamic.items[0]['Name-CN']=this.editFormData.IndentyName[0]['0x00-CN'] || this.editFormData.IndentyName[0]['false-CN'];
                            this.formDynamic.items[0]['Name-EN']=this.editFormData.IndentyName[0]['0x00-EN'] || this.editFormData.IndentyName[0]['false-EN'];
                            this.formDynamic.items[0]['LanguageKey']=this.editFormData.IndentyName[0]['0x00 LanguageKey'] || this.editFormData.IndentyName[0]['false LanguageKey'];
                            this.formDynamic.items[0]['wordId']=this.editFormData.IndentyName[0]['0x00 wordId'] || this.editFormData.IndentyName[0]['false wordId'];
                            this.formDynamic.items[0]['pageId_wordCode']=this.editFormData.IndentyName[0]['0x00 pageId_wordCode'] || this.editFormData.IndentyName[0]['false pageId_wordCode'];
                            this.formDynamic.items[0]['index']=1;
                            this.formDynamic.items[0]['status']=1;
                            this.formDynamic.items[1]['Code']=this.DataType==9?'0x01':'true';
                            this.formDynamic.items[1]['Name-CN']=this.editFormData.IndentyName[0]['0x01-CN'] || this.editFormData.IndentyName[0]['true-CN'];
                            this.formDynamic.items[1]['Name-EN']=this.editFormData.IndentyName[0]['0x01-EN'] || this.editFormData.IndentyName[0]['true-EN'];
                            this.formDynamic.items[1]['LanguageKey']=this.editFormData.IndentyName[0]['0x01 LanguageKey'] || this.editFormData.IndentyName[0]['true LanguageKey'];
                            this.formDynamic.items[1]['wordId']=this.editFormData.IndentyName[0]['0x01 wordId'] || this.editFormData.IndentyName[0]['true wordId'];
                            this.formDynamic.items[1]['pageId_wordCode']=this.editFormData.IndentyName[0]['0x01 pageId_wordCode'] || this.editFormData.IndentyName[0]['true pageId_wordCode'];
                            this.formDynamic.items[1]['index']=2;
                            this.formDynamic.items[1]['status']=1;
                            this.editFormData.IndentyName = JSON.parse(JSON.stringify([...this.formDynamic.items]))
                        }
                        this.setDefaultSelectPage()

                        this.index = this.editFormData.IndentyName.length
                    }
                    
                }else{
                    for(let i=0;i<this.formDynamic.items.length;i++){
                        if(this.$refs['select'+i]){

                            this.$refs['selcet'+i][0].clearVal()
                        }
                    }
                }
            },
            cancel() {//对话框关闭
                this.resetForm()
                this.$emit('update:showSetModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formDynamic.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                for(let i=0;i<this.formDynamic.items.length;i++){
                    if(this.$refs['select'+i]){
                        this.$refs['select'+i][0].clearVal()
                    }
                }
                this.formDynamic.items = common.deepClone([{...this.initData[0]},{...this.initData[1]}])
            }
        }
    }
</script>
<style lang="less" scoped>
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
        .ivu-select-dropdown {
            max-width: 250px;
        }
    }
     .ivu-modal-body {
        max-height: 800px;
         // overflow-y: scroll;
        overflow: auto;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
/deep/ .ivu-input[disabled]{
    background-color: #ffffff;
    color: #515a6e;
}
.delButton {
    /deep/ .ivu-form-item-content {
    margin-left: 20px !important;
}
}
</style>
